import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from '@carbon/react';
import { SettingsSkeleton } from 'src/components/Base/RequireCapability';
import SettingsNavDropdown from 'src/components/Layout/SettingsNavDropdown';
import SettingsSideNav from 'src/components/Layout/SettingsSideNav';
import { useSettingsNav } from 'src/hooks/useSettingsNav';

const SettingsLayout = React.memo(() => {
  const { t } = useTranslation();
  const { ready, sections, activeItem } = useSettingsNav();

  if (!ready) {
    return <SettingsSkeleton />;
  }

  return (
    <div className="settings-page">
      <SettingsSideNav sections={sections} />
      <div className="settings-page__body">
        <SettingsNavDropdown sections={sections} />
        <div className="settings-page__header">
          <Breadcrumb noTrailingSlash aria-label="Page navigation">
            <BreadcrumbItem>
              <Link to="/settings">{t('settingsNav.title')}</Link>
            </BreadcrumbItem>
            {activeItem && (
              <BreadcrumbItem>
                <Link to={activeItem.path}>{t(activeItem.labelKey)}</Link>
              </BreadcrumbItem>
            )}
          </Breadcrumb>
          <h1 className="settings-page__heading" id={'settings-heading'}>
            {activeItem ? t(activeItem.labelKey) : t('settingsNav.title')}
          </h1>
        </div>
        <div className="settings-page__main-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
});

export default SettingsLayout;
